// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__yVZlS","title":"styles_title__LfcDk","about":"styles_about__1uUFj"};
module.exports.__checksum = "293f9ec34e6e"